import { useEffect } from 'react';

export const SEO = ({ 
    title, 
    description, 
    keywords, 
    image, 
    url, 
    type = 'website',
    siteName = 'Mad Over Technology'
}) => {
    const baseUrl = typeof window !== 'undefined' ? window.location.origin : 'https://madovertech.io';
    const fullUrl = url ? `${baseUrl}${url}` : baseUrl;
    const imageUrl = image ? (image.startsWith('http') ? image : `${baseUrl}${image}`) : `${baseUrl}/mot_.png`;

    useEffect(() => {
        // Update title
        if (title) {
            document.title = title;
        }

        // Update or create meta tags
        const updateMetaTag = (name, content, attribute = 'name') => {
            let element = document.querySelector(`meta[${attribute}="${name}"]`);
            if (!element) {
                element = document.createElement('meta');
                element.setAttribute(attribute, name);
                document.head.appendChild(element);
            }
            element.setAttribute('content', content);
        };

        // Basic meta tags
        if (description) {
            updateMetaTag('description', description);
        }
        if (keywords) {
            updateMetaTag('keywords', keywords);
        }
        updateMetaTag('robots', 'index, follow');
        updateMetaTag('author', 'Mad Over Technology');
        updateMetaTag('viewport', 'width=device-width, initial-scale=1.0');

        // Open Graph tags
        updateMetaTag('og:title', title || 'Mad Over Technology | Interactive Technology Solutions Provider', 'property');
        updateMetaTag('og:description', description || 'Experiential tech, AI content, and gamified ideas designed to make your brand unforgettable.', 'property');
        updateMetaTag('og:image', imageUrl, 'property');
        updateMetaTag('og:url', fullUrl, 'property');
        updateMetaTag('og:type', type, 'property');
        updateMetaTag('og:site_name', siteName, 'property');
        updateMetaTag('og:locale', 'en_US', 'property');

        // Twitter Card tags
        updateMetaTag('twitter:card', 'summary_large_image');
        updateMetaTag('twitter:title', title || 'Mad Over Technology | Interactive Technology Solutions Provider');
        updateMetaTag('twitter:description', description || 'Experiential tech, AI content, and gamified ideas designed to make your brand unforgettable.');
        updateMetaTag('twitter:image', imageUrl);

        // Canonical URL
        let canonical = document.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement('link');
            canonical.setAttribute('rel', 'canonical');
            document.head.appendChild(canonical);
        }
        canonical.setAttribute('href', fullUrl);

        // Structured Data (JSON-LD)
        let structuredData = document.querySelector('script[type="application/ld+json"]');
        if (!structuredData) {
            structuredData = document.createElement('script');
            structuredData.setAttribute('type', 'application/ld+json');
            document.head.appendChild(structuredData);
        }

        const organizationSchema = {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Mad Over Technology",
            "url": baseUrl,
            "logo": `${baseUrl}/mot_.png`,
            "description": "Interactive Technology Solutions Provider specializing in AI Photo Booth, Field Force Management, and experiential tech solutions.",
            "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+91-9711689861",
                "contactType": "Customer Service",
                "email": "hello@madovertech.io",
                "areaServed": ["IN", "AE"],
                "availableLanguage": ["en", "hi"]
            },
            "sameAs": [
                "https://www.instagram.com/madovertechnology",
                "https://nexasync.io"
            ],
            "address": {
                "@type": "PostalAddress",
                "addressLocality": "Delhi",
                "addressCountry": "IN"
            }
        };

        structuredData.textContent = JSON.stringify(organizationSchema);
    }, [title, description, keywords, image, url, type, siteName, baseUrl, fullUrl, imageUrl]);

    return null;
};

